// Spinner.js
import React from "react";
import "./spinner.css"; // Contains the @keyframes definition

const Spinner = () => {
  // Inline styles for spinner
  const spinnerStyle = {
    width: "40px",
    height: "40px",
    border: "4px solid #ccc",
    borderTopColor: "#1d3f72",
    borderRadius: "50%",
    animation: "spin 1s ease-in-out infinite",
  };

  const containerStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%", // or a specific height
  };

  return (
    <div style={containerStyle}>
      <div style={spinnerStyle}></div>
    </div>
  );
};

export default Spinner;
